import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FiHome, FiShoppingBag } from 'react-icons/fi';

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found (404) | Panchali Boutique</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-[70vh] flex items-center justify-center px-4">
        <div className="max-w-lg w-full text-center">
          <p className="text-6xl sm:text-8xl font-light text-indigo-900/20 select-none">404</p>
          <h1 className="text-2xl sm:text-3xl font-light text-gray-800 mt-4">Page not found</h1>
          <div className="w-24 h-[2px] bg-gradient-to-r from-indigo-900 to-transparent mx-auto my-6" />
          <p className="text-gray-600 mb-10">
            The page you’re looking for doesn’t exist or has been moved.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-indigo-900 text-white font-medium rounded hover:bg-indigo-800 transition-colors"
            >
              <FiHome className="w-5 h-5" />
              Back to Home
            </Link>
            <Link
              to="/products"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-indigo-900 text-indigo-900 font-medium rounded hover:bg-indigo-50 transition-colors"
            >
              <FiShoppingBag className="w-5 h-5" />
              Shop
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
